const dragMixins = {
  data() {
    return {
      elPos:{//元素拖拽的位置
        x:0,
        y:0
      },
      dragpos:{//元素可拖拽的距离
        x:0,
        y:0
      }
    }
  },
  mounted() {
    this.elPos.x = document.body.clientWidth - 60
    this.elPos.y = document.body.clientHeight - 120
  },
  methods: {
    hanleMouseTouchStart(e){
      let touch = e
      if(e.touches){
        touch = e.touches[0]
      }
      this.dragpos.x = touch.clientX - this.$refs.dragEl.offsetLeft
      this.dragpos.y = touch.clientY - this.$refs.dragEl.offsetTop
    },
    hanleMouseTouchMove(e){
      e.preventDefault();
      let touch = e
      if(e.touches){
        touch = e.touches[0]
      }
      this.elPos.x = touch.clientX - this.dragpos.x
      this.elPos.y = touch.clientY - this.dragpos.y
      //限制拖拽元素位置不超过屏幕
      if(this.elPos.x < 0){
        this.elPos.x = 0
      }
      if(this.elPos.y < 0){
        this.elPos.y = 0
      }
      if(this.elPos.x > (window.screen.width - this.$refs.dragEl.clientWidth)){
        this.elPos.x = window.screen.width - this.$refs.dragEl.clientWidth
      }
      if(this.elPos.y > (window.screen.height - this.$refs.dragEl.clientHeight)){
        this.elPos.y = window.screen.height - this.$refs.dragEl.clientHeight
      }
    },
    hanleMouseTouchEnd(e){
      
    }
  },
}

export default dragMixins